// Common scrollbar styling
export const scrollbarClass = `
    [&::-webkit-scrollbar]:w-2 
    [&::-webkit-scrollbar]:h-2 
    [&::-webkit-scrollbar-track]:bg-gray-800/40
    [&::-webkit-scrollbar-thumb]:bg-gray-600
    [&::-webkit-scrollbar-thumb]:rounded-full
    [&::-webkit-scrollbar-track]:rounded-full
`;

// Cache expiration helper
export const isCacheExpired = (timestamp: number): boolean => {
    const TEN_MINUTES = 10 * 60 * 1000;
    return Date.now() - timestamp > TEN_MINUTES;
};
